const Titles = {
    "WELLCOME_TO_THE" : "Добро пожаловать",
    "LOGIN" : "ЛОГИН",
    "PASSWORD" : "ПАРОЛЬ",
    "DON'T_REMEMBER_PASSWORD" : "НЕ ПОМНЮ ПАРОЛЬ",
    "ENTER": "Войти",
    "REQUEST": "Оставить заявку",
    "SIGN_IN" : "Войти в систему",
    "EMAIL_OR_LOGIN" : "АДРЕС ЭЛЕКТРОННОЙ ПОЧТЫ ИЛИ ЛОГИН",
    "CONTINUE" : "Продолжить",
    "ABOUT_PRODUCT": "О продукте",
    "SITUABLE_FOR": "Кому подходит",
    "HOW_WORKS": "Как это работает",
    "ADVANTAGES": "Преимущества",
    "CONTACTS": "Контакты",
    "TELEGRAM": "Телеграм",
    "LANGUAGES": "Языки",
    "INFO_SOURCE": "Источники информации",
    "MEDIA_COUNT": "Количество СМИ",
    "KZ_COUNT": "Из них казахстанские",
    "SOCIAL_COUNT": "Аккаунты в соцсетях",
    "GET_MORE": "Узнать больше",
    "NAME": "Имя",
    "PHONE": "Номер телефона",
    "FIELD_NOT_BE_EMPTY": "Поле не может быть пустым",
    "PASSWORD_RESTORE" : "Восстановление пароля",
    "ONLY_NUMBERS_AND_LETTERS_AT_LEAST_3": "Только буквы и числа, не менее 3-х символов",
    "ONLY_NUMBERS_AND_LETTERS": "Только буквы и числа",
    "ONLY_LETTERS": "Только буквы",
    "A_LETTER_WITH_INSTRUCTIONS_WAS_SENT_TO_YOUR_EMAIL_ADDRESS" : "НА ВАШ АДРЕС ЭЛЕКТРОННОЙ ПОЧТЫ БЫЛО ОТПРАВЛЕНО ПИСЬМО С ИНСТРУКЦИЕЙ",
    "SORRY_SUCH_MAIL_OR_LOGIN_IS_NOT_REGISTERED" : "К СОЖАЛЕНИЮ, ТАКАЯ ПОЧТА ИЛИ ЛОГИН НЕ ЗАРЕГИСТРИРОВАНЫ",
    "TRY_AGAIN" : "Попробовать еще раз",
    "CANCEL" : "Отмена",
    "OBLIGATORY_FIELD": "Обязательно поле",
    "ONLY_NUMBER": "Не корректно введен номер телефона",
    "TOPICS_FOR_MONITORING": "Темы для мониторнига (ключевые слова)",
    "DEMONSTRATION_PRODUCT": "Демонстрация продукта",
    "GET_DEMO_LICENSE": "Нажимая “Получить демо-доступ ”, вы соглашаетесь с условиями ",
    "GET_DEMO_LICENSE_POLICY": " политики конфиденциальности ",
    "GET_DEMO_LICENSE_2": "и даете согласие на обработку персональных данных",
    "GET_DEMO_SUCCESS": "Запрос на предостовление демо доступа успешно отправлен.",
    "EMAIL_ADDRESS" : "Ваша электронная почта (формат: login@example.com)",
    "NOT_VALID_EMAIL" : "НЕ ВАЛИДНЫЙ АДРЕС ЭЛЕКТРОННОЙ ПОЧТЫ",
    "NEW_REVIEW_ON_MAP": "Новый отзыв на онлайн-карте",
    "GOOD_SERVICE": "Хороший сервис, рекомендую",
    "YOU_WERE_MENTIONED_IN_COMMENT": "Вас упомянули в комментарии",
    "USER_MENTIONED_YOU": "Пользователь @karina8800 упомянул вас в комментарии",
    "YOU_MENTIONED_ON_MEDIA": "ВАС УПОМЯНУЛИ В 1 СМИ",
    
    "CLOSE": "Закрыть",
    "MONITORING": "Мониторинг",
    "MEDIA_SOCIAL_BLOGS": "СМИ, соцсетей, блогов,",
    "REVIEWS_ON": "отзывов в ",
    "ONLINE_MAPS": "онлайн-картах",
    "TRACK_MEMORIES": "Отслеживайте упоминания, анализируйте тренды, прогнозируйте риски!",
    "MONITORING_FAVOURITVE_SOCIAL": "Мониторинг популярных соцсетей и СМИ (в том числе 5000 казахстанских), а также отзывов в онлайн-картах ",
    "GET_DEMO_ACCESS": "Получить демо-доступ",
    "WANT_DEMO_ACCESS": "Хочу демо-доступ",
    "KEYWORDS": "Ключевые слова",
    "TOPICS_AND_KEYWORDS": "Темы и ключевые слова",
    "KEYWORDS_DESCRIPTION": "Система автоматически собирает публикации, в тексте или в заголовке которых встречается хотя бы одно из заданных ключевых слов",
    "KEYWORDS_TEXT": "<ul><li>Вы задаёте ключевые слова — это могут быть термины, фразы или словосочетания.</li><li>Вся информация структурируется в удобной ленте, что упрощает анализ и отслеживание нужных упоминаний.</li></ul> Гибкость настройки позволяет быстро находить релевантные данные и эффективно управлять информационными потоками",

    "BIG_DATA": "Большие данные",
    "MEDIA": "СМИ",
    "REVIEWS_FROM_MAPS": "Отзывы из карт",
    "SOCIAL": "Соцсети",
    "MENTIONS": "Упоминания",
    "KEY_WORDS": "Ключевые слова",

    "BE_FIRST_TO_KNOW": "Узнайте первым",
    "WHO_WROTE_ABOUT": ", кто про вас написал в публикациях СМИ и постах социальных сетей",
    "MONITOR_THE_REPUTATION": "Контролируйте репутацию",
    "COMPANIES_BRANDS_TOP_MANAGMENT": " компании, бренда или ТОП-менеджента в любом информационном поле:",
    "MEDIA_SOCIAL_TELEGRAM": " СМИ, соцсети, телеграм каналы и отзывы в онлайн-картах",
    "GET_VALUABLE_INSIGHTS_BOLD": "Получайте",
    "GET_VALUABLE_INSIGHTS": " ценные инсайты",
    "IN_REALTIME": " в режиме реального времени о своих партнерах, клиентах или конкурентах прямо в Telegram или на электронную почту",

    "A_TOOL_FOR_STRATEGIC": " Инструмент для стратегического управления в политике, бизнесе, медиа и науке. Позволяет заранее выявлять риски и возможности, контролировать репутацию, отслеживать конкурентов и управлять информационными потоками для эффективных PR-кампаний.",

    "TOPIC_COMPARISON": "Сравнение тем",
    "TOPIC_COMPARISON_DESCRIPTION": "Система позволяет сопоставлять различные информационные потоки, выявлять закономерности и анализировать изменения в упоминаниях.",
    "TOPIC_COMPARISON_TEXT": "<ul><li>Выбирайте несколько тем для сравнения.</li> <li>Система анализирует их по ключевым метрикам: количество упоминаний, тональность, динамика распространения.</li> <li>Визуализация данных помогает выявить тренды, определить, какие темы набирают популярность, а какие теряют актуальность.</li> <li>Сравнивайте деятельность конкурентов для решения PR-задач.</li></ul> Этот инструмент позволяет быстро оценивать влияние информационных поводов и корректировать стратегии реагирования.",

    "SAMPLE": "Выборка",
    "SAMPLE_DESCRIPTION": "Система помогает быстро находить релевантные публикации в удобной ленте с гибкими фильтрами и сортировками.",
    "SAMPLE_TEXT": "<ul><li>Используйте расширенные фильтры по времени, источникам, тональности и ключевым словам.</li> <li>Система мгновенно формирует список упоминаний, соответствующих заданным критериям.</li> <li>Выбирайте только актуальную информацию, избегая информационного шума.</li> </ul>Этот инструмент позволяет оперативно анализировать данные, отслеживать тренды и принимать обоснованные решения.",

    "EXTENDED_ANALYTIC": "Развернутая аналитика",
    "EXTENDED_ANALYTIC_DESCRIPTION": "Система  предоставляет интерактивные дашборды для детального изучения информационного поля.",
    "EXTENDED_ANALYTIC_TEXT": "<ul><li>Анализируйте данные с помощью гибких фильтров по времени, источникам, тональности и ключевым метрикам.</li><li>Отслеживайте динамику трендов и аудиторные инсайты.</li><li>Визуализация данных в удобном формате помогает быстро находить закономерности и принимать обоснованные решения</li></ul> Этот инструмент позволяет получать ценные инсайты, прогнозировать изменения и корректировать стратегии в режиме реального времени.",

    "REPORTS": "Отчеты",
    "REPORTS_DESCRIPTION": "Система позволяет быстро формировать детализированные аналитические сводки в несколько кликов.",
    "REPORTS_TEXT": "<ul><li>Генерируйте отчёты по выбранным параметрам для глубокой аналитики.</li> <li>Экспортируйте данные в удобном формате (PDF, Excel, Word, JSON).</li> <li>Настройте автоматическую отправку отчётов заинтересованным сторонам.</li></ul> Этот инструмент упрощает работу с данными, помогая оперативно делиться аналитикой и принимать стратегические решения.",
    
    "DASHBOARDS": "Дашборды",
    "DASHBOARDS_DESCRIPTION": "Система позволяет быстро оценить ситуацию, предоставляя краткие и информативные метрики.",
    "DASHBOARDS_TEXT": "<ul><li>Вся ключевая информация представлена на одной странице.</li> <li>Отслеживайте основные метрики и тренды без необходимости углублённого анализа.</li> <li>Получайте быстрые инсайты для оперативного принятия решений.</li></ul> Этот инструмент помогает мгновенно оценивать динамику событий и быстро реагировать на изменения",

    "NOTIFICATIONS": "Уведомления",
    "NOTIFICATIONS_DESCRIPTION": "Система позволяет мгновенно получать оповещения о значимых изменениях в медиаполе.",
    "NOTIFICATIONS_TEXT": "<ul><li>Получайте уведомления в Telegram и на электронную почту.</li> <li>Отслеживайте новые публикации, тренды и важные изменения в режиме реального времени.</li> <li>Реагируйте оперативно, чтобы контролировать ситуацию и минимизировать риски.</li></ul>  Этот инструмент помогает всегда оставаться на шаг впереди и быстро принимать обоснованные решения",
    
    "MEDIAMONITORING": "медиамониторинг",
    "IN_ONLINE": "в режиме реального времени",
    "MEDIAMONITORING_DESCRIPTION_TEXT": "Полный обзор информационного поля: анализ публикаций, трендов и отзывов",
    "SOCIAL_MONITORING": "Мониторинг СМИ, соцсетей, отзывов в онлайн-картах",
    "LIVE_TRACKING": "Оперативное отслеживание новостей и упоминаний в режиме реального времени",
    "REPUTATION_ANALYSIS": "Анализ репутационных рисков компаний, руководителей и отраслей",
    "HISTORICAL_ANALYSIS": "Исторический анализ и долгосрочные тренды",
    "CONTENT_ANALYSIS": "Анализ контента на Казахском языке",
    "WRITERS_RATING": "Рейтинг пишущих о вас влиятельных СМИ и авторов с анализом тональности",

    "CONVENIENT_FILTERING": "Удобная фильтрация по заданным параметрам",
    "NOTIFICATIONS_ONLNE": "Уведомления в режиме реального времени",
    "STRUCTURED_SELECTION": "Структурированная подборка новостей ",
    "EXPORT_PUBLICATIONS": "Экспорт собранных публикаций",
    "USERS_NUMBER": "Количество пользователей в кабинете без ограничений",
    "INTERCATIVE_DASHBOARDS": "Интерактивные дашборды и отчёты",
    "SAVING_FILTERS": "Сохранение фильтров и настроек",

    "CONVENIENT_FILTERING_TEXT": "Интуитивные фильтры позволяют легко находить нужную информацию и формировать выборку",
    "NOTIFICATIONS_ONLNE_TEXT": "Получайте оповещения в Telegram и на почту о позитивных и негативных упоминаниях. Быстро реагируйте, снижайте репутационные риски и укрепляйте доверие к бренду",
    "ANALYTIC_TEXT": "Оценивайте масштаб и динамику упоминаний, выявляйте тренды, анализируйте тональность публикаций и прогнозируйте развитие репутационных тем",
    "STRUCTURED_SELECTION_TEXT": "Система автоматически собирает и упорядочивает свежие новости по заданным ключевым словам и темам, обеспечивая быстрый доступ к нужным публикациям",
    "EXPORT_PUBLICATIONS_TEXT": "Гибкие настройки экспорта упрощают работу - выгружайте отчеты в PDF, Word, Excel или JSON всего в пару кликов",
    "USERS_NUMBER_TEXT": "Подключайте неограниченное количество пользователей к аккаунту и управляйте доступом без лишних ограничений",
    "INTERCATIVE_DASHBOARDS_TEXT": "Наглядная аналитика и визуальные отчёты упрощают анализ данных, позволяя быстро получать ключевую информацию",
    "SAVING_FILTERS_TEXT": "Система позволяет сохранять фильтры для многократного использования настроек тем",
    "ASK": "Спросите",
    "EXPERT": "эксперта",
    "HAS_QUESTIONS": "У вас есть вопросы? Задайте их нашим специалистам",
    "SCOPE_ACTIVITY": "Сфера деятельности",
    "TELEPHONE": "Телефон",
    "YOUR_QUESTION": "Ваш вопрос",
    "ON_PRESSING_SUBMIT": "Нажимая “Отправить”, вы соглашаетесь с  ",
    "PRIVACY_POLICY_2": "Политика конфиденциальности",
    "PRIVACY_POLICY": "Политикой конфиденциальности",
    "PROCESSING_PERSONAL_DATA": "на обработку персональных данных",
    "SUBMIT": "Отправить",
    "RETURN": "Вернуться",
    "SEND_MESSAGE_SUCCESS": "Ваше сообщение успешно отправлено.",
    "OUR_PARTNERS": "Наши партнеры",

    "GOVERNMENT_BODIES": "Государственные органы:",
    "GOVERNMENT_BODIES_DESCRIPTION": "Правительство, акиматы, комитеты, управления, службы",
    "GOVERNMENT_BODIES_TEXT": "Мониторинг общественного мнения и контроль инфопотоков. Оценивайте реакцию общества и эффективность государственных инициатив в режиме реального времени",
    
    "POLITICAL_AND_PUBLIC_ORGANIZATIONS": "Политические и общественные организации:",
    "POLITICAL_AND_PUBLIC_ORGANIZATIONS_DESCRIPTION": "Партии, НПО, общественные объединения",
    "POLITICAL_AND_PUBLIC_ORGANIZATIONS_TEXT": "Анализ эффективности кампаний и борьба с дезинформацией. Оценивайте влияние политических и социальных инициатив, отслеживайте фейки и защищайте репутацию.",

    "BUSINESS_AND_FINANCE": "Бизнес и финансы:",
    "BUSINESS_AND_FINANCE_DESCRIPTION": "Компании, банки и финансовые организации",
    "BUSINESS_AND_FINANCE_TEXT": "Репутационный контроль и анализ рынка. Прогнозируйте риски, выявляйте инсайты и отслеживайте ключевые рыночные тренды.",

    "QUASI_PUBLIC_AND_PRIVATE_SECTOR": "Квази-государственный и частный сектор:",
    "QUASI_PUBLIC_AND_PRIVATE_SECTOR_DESCRIPTION": "Компании, крупные предприятия, частные учреждения ",
    "QUASI_PUBLIC_AND_PRIVATE_SECTOR_TEXT": "Управление репутацией и конкурентный анализ. Анализируйте рынок, отслеживайте упоминания и выстраивайте эффективную PR-стратегию.",

    "MEDIA_ANALYTICS_AND_PR": "Медиа, аналитика и PR:",
    "MEDIA_ANALYTICS_AND_PR_DESCRIPTION": "СМИ, PR-агентства, научно-исследовательские институты, аналитические центры",
    "MEDIA_ANALYTICS_AND_PR_TEXT": "Глубокая аналитика и выявление трендов. Анализируйте информационные потоки, отслеживайте ключевые темы и формируйте инсайты для эффективных стратегий.",
    "OFFERT": "Оферта",
    "TELEGRAM_BOT": "Telegram-бот",
    "FCBK": "ТОО Первое кредитное бюро",
    "RUS" : "Русский",
    "KAZ" : "Қазақ",
    "ENG" : "English",
};

export default Titles;